export class CreateEventDetailsModel {
  name: string
  startedAt: string
  homeTeamId: number
  awayTeamId: number
}
